import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';

// import { firebaseError } from 'utils';
import firebase from 'firebase.js';
import { checkUserData } from './auth';

const axios = require('axios').default;

const authBaseURL = `${process.env.REACT_APP_API_URL}`;

const instance = axios.create({
    baseURL: authBaseURL,
    timeout: 100000 // 100 seconds
});

const analytics = firebase.analytics();

export const USERS_FETCH_DATA_INIT = createAction('USERS_FETCH_DATA_INIT');
export const USERS_FETCH_DATA_SUCCESS = createAction(
    'USERS_FETCH_DATA_SUCCESS'
);
export const USERS_FETCH_DATA_FAIL = createAction('USERS_FETCH_DATA_FAIL');

export const USERS_DELETE_USER_INIT = createAction('USERS_DELETE_USER_INIT');
export const USERS_DELETE_USER_SUCCESS = createAction(
    'USERS_DELETE_USER_SUCCESS'
);
export const USERS_DELETE_USER_FAIL = createAction('USERS_DELETE_USER_FAIL');

export const USERS_CREATE_USER_INIT = createAction('USERS_CREATE_USER_INIT');
export const USERS_CREATE_USER_SUCCESS = createAction(
    'USERS_CREATE_USER_SUCCESS'
);
export const USERS_CREATE_USER_FAIL = createAction('USERS_CREATE_USER_FAIL');

export const USERS_MODIFY_USER_INIT = createAction('USERS_MODIFY_USER_INIT');
export const USERS_MODIFY_USER_SUCCESS = createAction(
    'USERS_MODIFY_USER_SUCCESS'
);
export const USERS_MODIFY_USER_FAIL = createAction('USERS_MODIFY_USER_FAIL');

export const USERS_CLEAN_UP = createAction('USERS_CLEAN_UP');

export const USERS_CLEAR_DATA_LOGOUT = createAction('USERS_CLEAR_DATA_LOGOUT');

export const fetchUsers = () => {
    return async (dispatch) => {
        dispatch(checkUserData());
        dispatch(USERS_FETCH_DATA_INIT());

        // const { id } = getState().auth.userData;
        let users = [];

        const authUser = JSON.parse(localStorage.getItem('authUser'));

        if (!authUser) {
            const message = 'Please login again';
            toastr.error('', message);
            return dispatch(USERS_FETCH_DATA_FAIL({ message }));
        }

        // decode the current token
        const base64Url = authUser.stsTokenManager.accessToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        const tokenData = JSON.parse(atob(base64));

        // check if expired
        if (tokenData.exp < Date.now() / 1000) {
            // token has expired
            // TODO either use firebase.auth() to check for user being updated first, before calling users

            // hardcoded sleep waiting for firebase to refresh token
            await new Promise(r => setTimeout(r, 5000));
            // reload the page
            window.location.reload();
        }

        instance.defaults.headers.authorization = authUser.stsTokenManager.accessToken;

        analytics.logEvent('get_users', authUser);

        try {
            // Make API request for users
            await instance.get('/v2/group/data') // eslint-disable-next-line
                .then(function (response) {
                    // handle success
                    users = [];
                    const groupData = response.data;
                    const userData = groupData.users;
                    // add an empty view at the start of the array
                    groupData.views.views.unshift({"view_id": 0, "view_label": ""}); // eslint-disable-next-line
                    userData.forEach(function (user) { 
                        const userObj = user;
                        userObj.id = user.user_id;
                        if (!user.name) {
                            userObj.name = 'Admin';
                        }

                        if (user.can_invite_users) {
                            userObj.isAdmin = true;
                        }
                        else {
                            userObj.isAdmin = false;
                        }
                        
                        userObj.views = groupData.views.views;
                        // if a user has a defaultViewId set it or default to 0
                        userObj.defaultViewId = user.settings ? user.settings.defaultViewId : 0;
                        users.push(userObj);
                    });

                }) // eslint-disable-next-line
                .catch(function (error) {
                    // handle error
                    toastr.error('', 'Error getting users');
                    return dispatch(USERS_FETCH_DATA_FAIL({ error }));
                });

        } catch (error) {
            toastr.error('', error);
            return dispatch(USERS_FETCH_DATA_FAIL({ error }));
        }

        return dispatch(
            USERS_FETCH_DATA_SUCCESS({
                data: users,
            })
        );
    };
};

export const deleteUser = (id) => {
    return async (dispatch) => {
        dispatch(USERS_DELETE_USER_INIT());

        try {
            const authUser = JSON.parse(localStorage.getItem('authUser'));

            if (!authUser) {
                const message = 'Please login again';
                toastr.error('', message);
                return dispatch(USERS_FETCH_DATA_FAIL({ message }));
            }

            instance.defaults.headers.authorization = authUser.stsTokenManager.accessToken;
            
            const requestData = {
                user_id: id
            };

            analytics.logEvent('get_users', requestData);

            // Make a request to delete user
            // TODO find a better way to sent delete request using instance
            await axios.delete(''.concat(authBaseURL, '/group/users'), {
                headers: {
                    'authorization': authUser.stsTokenManager.accessToken
                },
                data: requestData
            }) // eslint-disable-next-line
            .then(function () {
                // handle success
                toastr.success('', 'The user was deleted.');
                return dispatch(USERS_DELETE_USER_SUCCESS({ id }));
                
            }) // eslint-disable-next-line
            .catch(function (error) {
                toastr.error('', 'Error deleting user');
                return dispatch(USERS_CREATE_USER_FAIL({ error }));
            });

        } catch (error) {
            toastr.error('', 'Error deleting user');
            return dispatch(USERS_CREATE_USER_FAIL({ error }));
        }
        return null;
        
    };
};

export const clearUsersDataLogout = () => {
    return (dispatch) => {
        dispatch(USERS_CLEAR_DATA_LOGOUT());
    };
};

export const createUser = ({
    name,
    email,
    isAdmin,
    defaultViewId
}) => {
    return async (dispatch) => {
        dispatch(USERS_CREATE_USER_INIT());
        let userData;
        // const { locale } = getState().preferences;

        const authUser = JSON.parse(localStorage.getItem('authUser'));

        if (!authUser) {
            const message = 'Please login again';
            toastr.error('', message);
            return dispatch(USERS_FETCH_DATA_FAIL({ message }));
        }

        instance.defaults.headers.authorization = authUser.stsTokenManager.accessToken;

        let canInvite = false;
        if (isAdmin === true)
            canInvite = true;
        // TODO allow send_email to be defined from the frontend

        const settings = {};
        if (defaultViewId)
            settings.defaultViewId = defaultViewId;

        const requestData = {
            "name": name,
            "email": email,
            "can_invite_users": canInvite,
            "send_email": true,
            "settings": settings
        };

        analytics.logEvent('create_user', requestData);

        try {

            // Make a request to create user
            
            await instance.post('/group/users', requestData) // eslint-disable-next-line
                .then(function (response) {
                    // handle success
                    userData = response.data;

                    /*
                    removed sending workaround PasswordResetEmail, use sendgrid and send_email flag instead
                    const actionCodeSettings = {
                        // URL you want to redirect back to. The domain (www.example.com) for this URL
                        // must be whitelisted in the Firebase Console.
                        'url': window.location.href, // Here we redirect back to this same page.
                        'handleCodeInApp': true // This must be true.
                    };
                    // await firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings);
                    firebase.auth().sendPasswordResetEmail(email, actionCodeSettings);
                    */

                }) // eslint-disable-next-line
                .catch(function (errorMessage) {
                    // handle error
                    // const errorMessage = firebaseError(500, locale);
                    toastr.error('', 'Error creating user');
                    return dispatch(
                        USERS_CREATE_USER_FAIL({
                            error: errorMessage,
                        })
                    );
                });

        } catch (error) {
            toastr.error('', error);
            return dispatch(USERS_CREATE_USER_FAIL({ error }));
        }
        if (userData)
            toastr.success('', 'User created successfully');
        return dispatch(USERS_CREATE_USER_SUCCESS({ user: userData }));
    };
};

export const modifyUser = ({
    name,
    isAdmin,
    id,
    defaultViewId
}) => {
    return async (dispatch) => {
        dispatch(USERS_MODIFY_USER_INIT());

        let userData;
        const authUser = JSON.parse(localStorage.getItem('authUser'));

        if (!authUser) {
            const message = 'Please login again';
            toastr.error('', message);
            return dispatch(USERS_FETCH_DATA_FAIL({ message }));
        }

        instance.defaults.headers.authorization = authUser.stsTokenManager.accessToken;

        const settings = {};
        if (defaultViewId)
            settings.defaultViewId = defaultViewId;
        
        let canInvite = false;
        if (isAdmin === true)
            canInvite = true;

        const requestData = {
            "name": name,
            "can_invite_users": canInvite,
            "user_id": id,
            "settings": settings
        };

        analytics.logEvent('update_user', requestData);

        try {
            // modifyUser via API

            await instance.put('/group/users', requestData) // eslint-disable-next-line
                .then(function (response) {
                    // handle success
                    userData = response.data;
                }) // eslint-disable-next-line
                .catch(function (error) {
                    // handle error
                    toastr.error('', 'Error updating user');
                    return dispatch(USERS_CREATE_USER_FAIL({ error }));
                });

        } catch (error) {
            toastr.error('', error);
            return dispatch(USERS_CREATE_USER_FAIL({ error }));
        }

        return dispatch(USERS_MODIFY_USER_SUCCESS({ user: userData, id }));
    };
};

export const usersCleanUp = () => (dispatch) => dispatch(USERS_CLEAN_UP());
